import { Pipe, PipeTransform } from '@angular/core';
import { AccountState } from '@account-users/account/models';

import { LicenseV2 } from '../state/feature-toggles/models';

@Pipe({
  name: 'featureToggleColor',
})
export class FeatureToggleColorPipe implements PipeTransform {
  transform(value: LicenseV2): string {
    return value?.enabled && value?.state === AccountState.Failed
      ? 'danger'
      : 'success';
  }
}
